export default "__VITE_ASSET__c8830bba__"